
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-cover-letter",
      function () {
        return require("private-next-pages/ai-cover-letter/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-cover-letter"])
      });
    }
  